export default "__VITE_ASSET__DXHKB_1p__"